import React from "react";

interface CheckinSectionProps {
  title: string;
  step?: number;
  children: React.ReactNode;
}

export const CheckinSection = ({ title, step, children }: CheckinSectionProps) => {
  return (
    <section className="bg-card border shadow-soft rounded-3xl p-5 mb-5 space-y-4">
      <div className="flex items-center gap-2">
        {step && (
          <span className="w-6 h-6 rounded-full bg-primary/10 text-primary flex items-center justify-center text-xs font-bold shrink-0">
            {step}
          </span>
        )}
        <h2 className="text-base font-bold text-foreground">{title}</h2>
      </div>
      <div className="space-y-5">
        {children}
      </div>
    </section>
  );
};
